<template>
  <layout-main-inner
    v-loading="loading"
    :title="$route.meta.name">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入企业名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="申请人信息"
          min-width="110">
          <el-table-column
            label="企业名称"
            min-width="160"
            show-overflow-tooltip
            prop="corpName"> </el-table-column>
          <el-table-column
            label="联系人"
            min-width="80"
            prop="contactMan">
          </el-table-column>
          <el-table-column
            label="联系电话"
            prop="contactPhone"
            min-width="110"></el-table-column>
          <el-table-column
            label="邮箱"
            prop="contactEmail"
            show-overflow-tooltip
            min-width="110"></el-table-column>
        </el-table-column>
        <el-table-column
          label="被申请人信息"
          min-width="110">
          <el-table-column
            label="企业名称"
            min-width="160"
            show-overflow-tooltip
            prop="otherPartyCorpName"> </el-table-column>
          <el-table-column
            label="联系人"
            min-width="80"
            prop="otherPartyContactMan">
          </el-table-column>
          <el-table-column
            label="联系电话"
            prop="otherPartyContactPhone"
            min-width="110"></el-table-column>
          <el-table-column
            label="邮箱"
            prop="otherPartyContactEmail"
            show-overflow-tooltip
            min-width="110"></el-table-column>
        </el-table-column>
        <el-table-column
          label="涉及金额"
          min-width="100"
          :formatter="row => row.amount + '元'"
          prop="amount"> </el-table-column>
        <el-table-column
          label="状态"
          min-width="60"
          :formatter="row => row.status === 0 ? '待处理' : '已处理'"
          prop="status"> </el-table-column>
        <el-table-column
          fixed="right"
          label="纠纷描述"
          min-width="80"
          prop="issueDesc">
          <template slot-scope="{ row }">
            <el-popover
              title="纠纷描述"
              width="280"
              trigger="hover"
              :content="row.issueDesc">
              <el-button
                slot="reference"
                type="text">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="申请人诉求"
          prop="appeal"
          min-width="90">
          <template slot-scope="{ row }">
            <el-popover
              title="申请人诉求"
              width="280"
              trigger="hover"
              :content="row.appeal">
              <el-button
                slot="reference"
                type="text">查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          :width="60">
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.status === 1"
              type="text"
              @click="checkItem(row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import Common from '@/service/common'
export default {
  name: 'DisputesListTable',
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, vendorName: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    checkItem(row) {
      this.$confirm('是否立即处理该调解单?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Common.updatedispute({ id: row.id, status: 1 })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('处理成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Common.getdisputes({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0].includes(result)) {
            this.total = total
            this.list = records.map(i => ({ ...i, labelName: (i.labels || []).join('，'), businessName: (i.companyBusinessCategorys || []).join('，') }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
